import { Link } from 'react-router-dom';
import MarkdownText from './MarkdownText';

const TEACHER_VERDICT_ICONS = {
  ACCEPTED: { icon: 'fa-check', label: 'Принять' },
  REVIEW_IN_LESSON: { icon: 'fa-chalkboard-user', label: 'На занятии' },
  REDO: { icon: 'fa-rotate-left', label: 'Переделать' },
};

/**
 * Компактная строка задачи в списке занятия (режим наставника).
 */
export default function TeacherTaskListRow({
  title,
  report,
  reportTitle,
  statusClass,
  index,
  total,
  canManage,
  listManageSaving,
  attemptId,
  teacherVerdict,
  commentText,
  statementExpanded,
  statementText,
  statementLoading,
  taskHref,
  titleHint,
  isTeacherHere,
  isStudentHere,
  showVerdict = true,
  onTitleClick,
  onMoveUp,
  onMoveDown,
  onRemove,
  onVerdict,
  onOpenComment,
  onToggleStatement,
}) {
  const hasComment = Boolean(commentText && String(commentText).trim());
  const titleClass = 'teacher-task-list-row-title';
  const titleInner = (
    <>
      {title}{' '}
      <span className={`report-badge ${statusClass}`} title={reportTitle || undefined}>{report}</span>
    </>
  );

  return (
    <div className="teacher-task-list-row-wrap">
      <div className="teacher-task-list-row">
        {canManage ? (
          <span className="teacher-task-list-row-order">
            <button
              type="button"
              className="btn btn-outline btn-xs btn-icon-only"
              disabled={listManageSaving || index <= 0}
              onClick={onMoveUp}
              title="Выше"
              aria-label="Выше"
            >
              <i className="fa-solid fa-chevron-up ui-icon" aria-hidden />
            </button>
            <button
              type="button"
              className="btn btn-outline btn-xs btn-icon-only"
              disabled={listManageSaving || index >= total - 1}
              onClick={onMoveDown}
              title="Ниже"
              aria-label="Ниже"
            >
              <i className="fa-solid fa-chevron-down ui-icon" aria-hidden />
            </button>
          </span>
        ) : null}
        <span
          className="teacher-task-list-row-markers"
          aria-hidden={!isTeacherHere && !isStudentHere}
        >
          <span
            className={`teacher-task-list-marker teacher-task-list-marker-teacher${isTeacherHere ? ' is-on' : ''}`}
            title={isTeacherHere ? 'Вы здесь' : undefined}
          />
          <span
            className={`teacher-task-list-marker teacher-task-list-marker-student${isStudentHere ? ' is-on' : ''}`}
            title={isStudentHere ? 'Ученик здесь' : undefined}
          />
        </span>
        {taskHref ? (
          <Link
            to={taskHref}
            className={`${titleClass} teacher-task-list-row-title-link`}
            title={titleHint || title}
            onClick={onTitleClick}
          >
            {titleInner}
          </Link>
        ) : (
          <span className={titleClass} title={titleHint || title}>
            {titleInner}
          </span>
        )}
        <span className="teacher-task-list-row-actions">
          {attemptId ? (
            <>
              <button
                type="button"
                className={`btn btn-xs btn-icon-only ${hasComment ? 'btn-primary teacher-task-comment-has' : 'btn-outline'}`}
                onClick={onOpenComment}
                title={hasComment ? 'Комментарий (есть текст)' : 'Комментарий к последней попытке'}
                aria-label={hasComment ? 'Комментарий (есть текст)' : 'Комментарий'}
              >
                <i className={`fa-${hasComment ? 'solid' : 'regular'} fa-comment ui-icon`} aria-hidden />
              </button>
              {showVerdict
                ? ['ACCEPTED', 'REVIEW_IN_LESSON', 'REDO'].map((v) => {
                    const meta = TEACHER_VERDICT_ICONS[v];
                    const active = teacherVerdict === v;
                    return (
                      <button
                        key={v}
                        type="button"
                        className={`btn btn-xs btn-icon-only ${active ? 'btn-primary' : 'btn-outline'}`}
                        onClick={() => onVerdict(v)}
                        title={meta.label}
                        aria-label={meta.label}
                        aria-pressed={active}
                      >
                        <i className={`fa-solid ${meta.icon} ui-icon`} aria-hidden />
                      </button>
                    );
                  })
                : null}
            </>
          ) : null}
          {canManage ? (
            <button
              type="button"
              className="btn btn-outline btn-xs btn-icon-only"
              disabled={listManageSaving}
              onClick={onRemove}
              title="Удалить из списка"
              aria-label="Удалить из списка"
            >
              <i className="fa-solid fa-trash ui-icon" aria-hidden />
            </button>
          ) : null}
          <button
            type="button"
            className={`btn btn-outline btn-xs btn-icon-only ${statementExpanded ? 'active' : ''}`}
            onClick={onToggleStatement}
            title={statementExpanded ? 'Свернуть условие' : 'Показать условие'}
            aria-label={statementExpanded ? 'Свернуть условие' : 'Показать условие'}
            aria-expanded={statementExpanded}
          >
            <i className={`fa-solid fa-chevron-${statementExpanded ? 'up' : 'down'} ui-icon`} aria-hidden />
          </button>
        </span>
      </div>
      {statementExpanded ? (
        <div className="teacher-task-list-statement">
          {statementLoading ? (
            <span className="text-secondary text-sm">Загрузка…</span>
          ) : statementText ? (
            <MarkdownText text={statementText} className="teacher-task-list-statement-md" />
          ) : (
            <span className="text-secondary text-sm">Нет текста условия</span>
          )}
        </div>
      ) : null}
    </div>
  );
}
